/**
 * Controla la configuración de la aplicación
 */

export const settings = {

  // firebase config

  firebase: {
    config: {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_FIREBASE_APP_ID,
      measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
    }
  },

  // react-redux-firebase config

  reactReduxFirebase: {
    config: {
      userProfile: process.env.REACT_APP_REACT_REDUX_FIREBASE_USER_PROFILE,
      useFirestoreForProfile: process.env.REACT_APP_REACT_REDUX_FIREBASE_USE_FIRESTORE_FOR_PROFILE === 'true'
    }
  }

}